<template>
  <div>
    <div class="d-flex justify-end align-center pa-6">
      <v-spacer></v-spacer>
      <v-btn color="green" dark outlined @click="exportExcel">
        <v-icon left> mdi-file-excel-outline</v-icon>Xuất Excel
      </v-btn>
    </div>
    <v-data-table
      class="px-6"
      :headers="headers"
      :items="diligences"
      item-key="id"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
    >
      <template v-slot:[`item.uncheckNumber`]="{ item }">
        <div v-if="item.uncheckNumber > 0" style="color: red">{{ item.uncheckNumber }}</div>
        <div v-else>{{ item.uncheckNumber }}</div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn class="elevation-0" icon @click="viewDetail(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Diligence } from '@/plugins/api'
import utils from '../../../plugins/utils'
import moment from 'moment'

const defaultHeaders = [
  {
    text: 'Ngày',
    value: 'date',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Sĩ số',
    value: 'studentNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Có mặt',
    value: 'presentNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Đi muộn',
    value: 'invalidPresentNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Vắng mặt',
    value: 'absentNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Có phép',
    value: 'validNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Không phép',
    value: 'invalidNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Chưa xác định',
    value: 'uncheckNumber',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: false,
    show: true
  }
]
export default {
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5
      },
      selectedDiligence: null,
      addDiligence: false,
      studentSearchParams: {},
      diligences: [],
      classCount: 0,
      loading: false,
      dialog: false
    }
  },
  props: {
    filters: Object,
    currClass: Object
  },
  components: {},
  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số lớp mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5
      }
      return footerOptions
    }
  },
  methods: {
    async searchStudentDiligences() {
      this.$loading.active = true
      this.loading = true
      if (this.filters) {
        this.tableOptions.page = 1
      }
      try {
        this.diligences = await Diligence.getDiligenceByClass({ ...this.filters, ...this.pageSetting() })
        this.classCount = this.diligences.length
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần')
        console.error(error)
      }
      this.loading = false
      this.$loading.active = false
    },
    pageSetting() {
      return {}
    },
    openDialog(item) {
      this.selectedDiligence = item
      this.$nextTick(() => {
        this.dialog = !this.dialog
      })
    },
    viewDetail(item) {
      const url = `/attendances?diligence=true&date=${item.date}&class=${item.class.id}`
      window.open(url, '_blank')
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = defaultHeaders
        const excelHeader = headers
          .map(({ text, value }) => ({ text, value }))
          .filter(excel => excel.value !== 'action')
        const list = this.diligences
        const data = JSON.parse(JSON.stringify(list))
        const startDate = moment(this.filters.date_gte)
          .utcOffset(7)
          .format('DD/MM/YYYY')
        const endDate = moment(this.filters.date_gte)
          .utcOffset(7)
          .format('DD/MM/YYYY')
        utils.exportExcel(
          data,
          excelHeader,
          `${this.currClass ? this.currClass.title : ''}-${startDate}-${endDate}_ChuyenCan`
        )
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  watch: {}
}
</script>
